var React = require('react');

function AddDropdown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},React.createElement("path",{"d":"M9.96 8.04h3.02a.5.5 0 0 1 .5.5v.92a.5.5 0 0 1-.5.5H9.96v3.02a.5.5 0 0 1-.5.5h-.92a.5.5 0 0 1-.5-.5V9.96H5.02a.5.5 0 0 1-.5-.5v-.92a.5.5 0 0 1 .5-.5h3.02V5.02a.5.5 0 0 1 .5-.5h.92a.5.5 0 0 1 .5.5v3.02zM12.44 14.04h5.12l-2.535 2.72z"})));
}

AddDropdown.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = AddDropdown;

AddDropdown.default = AddDropdown;
